export default __webpack_public_path__ + "static/media/00655-3308190209.0ecc50b6.webp";